<template>
  <el-dialog :custom-class="$i18n.locale === 'zh' ?'editUser' :'eneditUser'"  :visible.sync="editState" :before-close="edithiden">
      <div slot="title" class="el-dialog__title"><div class="title-left"></div><slot name="title">{{$t('managementV2.edit')}}</slot><div class="title-right"></div></div>
      <el-form :rules="rules" :model="form" ref="form">

        <el-form-item v-if="!(IS_PRIVATE||IS_ONLINE_PRIVATE)" :label="$t('managementV2.phone')" class="emailForm">
          <el-input v-model="form.loginPhone" :readonly="true"></el-input>
        </el-form-item>
        <el-form-item v-else :label="$t('managementV2.email')" class="emailForm">
          <el-input v-model="form.email" :readonly="true"></el-input>
        </el-form-item>

        <el-form-item prop="name" :label="$t('managementV2.name')">
          <el-input v-model.trim="form.name" :readonly="false" ></el-input>
        </el-form-item>

        <el-form-item v-if="roleLevel !== 0" :label="$t('managementV2.role')" prop="role">
          <el-select v-model="form.role" :placeholder="$t('managementV2.pleaseselectRoles')" @change="editChanged">
            <el-option v-for="item in roleId"  :label="$i18n.locale === 'zh' ?item.name:$roleCase[item.roleType]" :key="item.id" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="roleLevel !== 0" :label="$t('managementV2.jurisdiction')" prop="authority" class="authoritybox" :rules="[
            {
              type: 'array',
              required: true,
              message: $t('managementV2.onePermission'),
              trigger: ['change'],
            },
          ]">
          <el-checkbox-group v-model="form.authority">
            <el-checkbox :label="item.id" v-for="item in AllResource" :key="item.id" :style="TEAM_DEFAULT_AUTH.includes(item.name)?'display:none;':''" name="authority" @change="checkChange(item.id)">{{ changeRoleName(item) }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" :class="roleLevel !== 0 ? 'dialog-footer' : 'dialog-footer2'">
        <el-button @click="edithiden">{{$t("managementV2.cancel")}}</el-button>
        <el-button type="primary" @click="editSure()">{{$t("managementV2.determine")}}</el-button>
      </div>
  </el-dialog>
</template>

<script>
import { getRoleId, getAllResource } from "@/services/teamManagement.js";

export default {
  name: "editUser",
  props: {
    editState: {
      type: Boolean,
    },
    editData: {
      type: Object,
    },
    roleId: {
      type: Array,
    },
  },
  data() {
    var username = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error(this.$t('project.nameTip')));
      } else if (value.length < 2) {
        callback(new Error(this.$t('managementV2.nameContainsMin')));
      } else if (value.length > 10) {
        callback(new Error(this.$t('managementV2.nameContainsMax')));
      }
      callback();
    };
    return {
      IS_PRIVATE: IS_PRIVATE, // 独立部署
      IS_ONLINE_PRIVATE: IS_ONLINE_PRIVATE,
      TEAM_DEFAULT_AUTH: typeof TEAM_DEFAULT_AUTH === 'undefined'? [] : TEAM_DEFAULT_AUTH,
      form: {
        email: "",
        loginPhone: "",
        name: "",
        role: "",
        authority: [],
      },
      id: "",
      loginPhone: "",
      roleIds: "",
      AllResource: [],
      roleLevel: 0,
      memoryBank: [],
      glossaryBank: [],
      corpus: [],
      rules: {
        name: [{ required: true, validator: username, trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.getAllResources();
  },
  methods: {
    //记忆库，术语库，语料库 选择
    checkChange(val) {
      if (val == this.corpus[0].id) {
        // console.log(this.form.authority);
        if (this.form.authority.includes(this.corpus[0].id)) {
          this.form.authority.push(
            this.memoryBank[0].id,
            this.glossaryBank[0].id
          );
        } else {
          if (
            this.form.authority.includes(this.memoryBank[0].id) ||
            this.form.authority.includes(this.glossaryBank[0].id)
          ) {
            let memoryBankIndex = this.form.authority.indexOf(
              this.memoryBank[0].id
            );
            this.form.authority.splice(memoryBankIndex, 1);
            let glossaryBankIndex = this.form.authority.indexOf(
              this.glossaryBank[0].id
            );
            this.form.authority.splice(glossaryBankIndex, 1);
          }
        }
      }

      if (val == this.memoryBank[0].id || val == this.glossaryBank[0].id) {
        if (
          this.form.authority.includes(this.memoryBank[0].id) ||
          this.form.authority.includes(this.glossaryBank[0].id)
        ) {
          this.form.authority.push(this.corpus[0].id);
        } else {
          let corpusSubscript = this.form.authority.indexOf(this.corpus[0].id);
          this.form.authority.splice(corpusSubscript, 1);
        }
      }

      this.form.authority = Array.from(new Set(this.form.authority));
    },
    //获取角色名称
    changeRoleName(item) {
      return this.$i18n.locale === 'zh' ? item.name : item.nameEn;
      // switch (item.name) {
      //   case "语料库":
      //     return this.$t('managementV2.corpusManagement');
      //   case "项目管理":
      //     return this.$t('managementV2.projectManagement');
      //   case "我的任务":
      //     return this.$t('managementV2.myAssignment');
      //   case "团队管理":
      //     return this.$t('managementV2.teamManagement');
      //   case "记忆库":
      //     return this.$t('managementV2.translationMemoryLibraryManagement');
      //   case "术语库":
      //     return this.$t('managementV2.glossaryManagement');
      //   case "用户指南":
      //     return this.$t('managementV2.userGuide');
      // }
    },
    //获取全部资源
    async getAllResources() {
      const res = await getAllResource();
      if (res.success && res.status == 200) {
        this.AllResource = res.result;
        this.memoryBank = this.AllResource.filter((item) => {
          return item.name == "记忆库";
        });
        this.glossaryBank = this.AllResource.filter((item) => {
          return item.name == "术语库";
        });
        this.corpus = this.AllResource.filter((item) => {
          return item.name == "语料库";
        });
      }
    },
    edithiden() {
      this.form.name = this.editData.aliasName;
      this.$refs.form.clearValidate();
      this.$emit("edithiden");
    },
    editSure() {
      let roleLevel = null;
      // 如果是超级管理员，roleLevel不变
      if (this.roleLevel === 0) {
        roleLevel = this.roleLevel;
      } else {
        if (this.form.authority.length < 1) {
          this.$message.closeAll();
          this.$message.warning(this.$t("managementV2.pleaseChoosejurisdiction"));
          return;
        }
        roleLevel = this.roleId.find(item =>this.form.role === item.id).roleLevel;
      }
      let params = {
        email: this.form.email,
        aliasName: this.form.name,
        id: this.id,
        loginPhone: this.loginPhone,
        resourceIds: this.form.authority,
        roleId: this.form.role,
        roleLevel
      };
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.$emit("editSure", params);
      });
    },
    async editChanged() {
      let params = {
        id: this.form.role,
        resType: 'CATWEB',
      };
      const res = await getRoleId(params);
      if (res.success) {
        // 拿到     CAT     菜单的权限
        // let arr = res.result.filter(item => item.resType === 'CATWEB').slice(0,6);
        this.form.authority = res.result.map((item) => {
          return item.id;
        });
      }
    },
  },

  watch: {
    editData: {
      handler(val) {
        this.form.email = val.email;
        this.form.loginPhone = val.loginPhone;
        this.form.name = val.aliasName;
        this.form.role = val.roleId;
        this.id = val.id;
        this.loginPhone = val.loginPhone;
        this.roleIds = val.roleId;
        this.form.authority = val.resourceIdList || [];
        this.roleLevel = val.roleLevel;
      },
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>